import { styled } from '@mui/system'
import { ReactComponent as SquareIcon } from '../../../assets/images/shapes/square.svg'
import { ReactComponent as CircleIcon } from '../../../assets/images/shapes/circle.svg'
import { ReactComponent as TriangleUpIcon } from '../../../assets/images/shapes/triangle-up.svg'
import { ReactComponent as TriangleDownIcon } from '../../../assets/images/shapes/triangle-down.svg'
import { ReactComponent as DiamondIcon } from '../../../assets/images/shapes/diamond.svg'
import { ReactComponent as PentagonIcon } from '../../../assets/images/shapes/pentagon.svg'
import { ReactComponent as HexagonIcon } from '../../../assets/images/shapes/hexagon.svg'
import { ReactComponent as CogIcon } from '../../../assets/images/cog.svg'
import { ActivityStatusConfig } from './useActivityStatuses.types'

// Canonicalize external connector status labels that leak into stored data.
// Mirrors server/utils/activity-status-mapping.js — keep the two in sync.
export const STATUS_ALIASES: Record<string, string> = {
    Complete: 'Completed',
    Active: 'Initiated',
}

export const normalizeActivityStatus = (raw: string | undefined | null): string | undefined => {
    if (raw == null) return undefined
    const trimmed = String(raw).trim()
    if (!trimmed) return undefined
    return STATUS_ALIASES[trimmed] ?? trimmed
}

export const getActivityStatusDetailsIcon = (activityStatusConfig: Pick<ActivityStatusConfig, 'shape' | 'color'>) => {
    const getIconByShape = (shape: ActivityStatusConfig['shape']) => {
        switch (shape) {
            case 'square':
                return SquareIcon
            case 'circle':
                return CircleIcon
            case 'triangle-up':
                return TriangleUpIcon
            case 'triangle-down':
                return TriangleDownIcon
            case 'diamond':
                return DiamondIcon
            case 'pentagon':
                return PentagonIcon
            case 'hexagon':
                return HexagonIcon

            default:
                return CogIcon
        }
    }

    return styled(getIconByShape(activityStatusConfig.shape))({
        color: `${activityStatusConfig.color} !important`,
    })
}
